import { createClient } from '@supabase/supabase-js';

// Define database types for better TypeScript support
export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          nickname: string;
          name: string | null;
          city: string | null;
          created_at: string;
          last_login_at: string | null;
        };
        Insert: {
          id: string;
          email: string;
          nickname: string;
          name?: string | null;
          city?: string | null;
          created_at?: string;
          last_login_at?: string | null;
        };
        Update: {
          id?: string;
          email?: string;
          nickname?: string;
          name?: string | null;
          city?: string | null;
          created_at?: string;
          last_login_at?: string | null;
        };
      };
      books: {
        Row: {
          id: string;
          title: string;
          author: string;
          category: string;
          language: string;
          status: string;
          owner_id: string;
          current_holder: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          title: string;
          author: string;
          category: string;
          language: string;
          status?: string;
          owner_id: string;
          current_holder?: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          title?: string;
          author?: string;
          category?: string;
          language?: string;
          status?: string;
          owner_id?: string;
          current_holder?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
      requests: {
        Row: {
          id: string;
          book_id: string;
          owner_id: string;
          reader_id: string;
          status: string;
          address: string;
          phone: string;
          courier_cost: number | null;
          estimated_days: number | null;
          upi_id: string | null;
          tracking_number: string | null;
          notes: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          book_id: string;
          owner_id: string;
          reader_id: string;
          status?: string;
          address: string;
          phone: string;
          courier_cost?: number | null;
          estimated_days?: number | null;
          upi_id?: string | null;
          tracking_number?: string | null;
          notes?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          book_id?: string;
          owner_id?: string;
          reader_id?: string;
          status?: string;
          address?: string;
          phone?: string;
          courier_cost?: number | null;
          estimated_days?: number | null;
          upi_id?: string | null;
          tracking_number?: string | null;
          notes?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
};

let _client: any = null;

/**
 * Reads Supabase URL and anon key from Vite env.
 * Define in webadmin/.env.local:
 *   VITE_SUPABASE_URL=...
 *   VITE_SUPABASE_ANON_KEY=...
 */
export function getSupabaseClient() {
  if (_client) return _client;

  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

  if (!url || !anon) {
    throw new Error('[Shiriki Admin] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in environment variables');
  }

  _client = createClient<Database>(url, anon, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  });
  return _client;
}